module.exports = __webpack_public_path__ + "img/signup-logo-light.dd3d8bcc.svg";